"use client";

import { createContext, useContext } from "react";
import type { CaseLabelSettings } from "@/cms/case-labels";

const CaseLabelContext = createContext<CaseLabelSettings>({});
export const useCaseLabelSettings = () => useContext(CaseLabelContext);

export default function CaseLabelProvider({
  settings,
  children,
}: {
  settings?: CaseLabelSettings;
  children: React.ReactNode;
}) {
  return (
    <CaseLabelContext.Provider value={settings ?? {}}>
      {children}
    </CaseLabelContext.Provider>
  );
}
